<!--
 Created by Daniil Vat. on 18/2/2021
 Copyright © 2021 Curriculum Ltd. All rights reserved.
-->
<div class="statistic-expansion-panel">
  <div class="panel" [ngClass]="{ open: isShowed, error: isError }" (clickOutside)="closeDropDown()">
    <div class="custom-select" [class.disabled]="isDisabled" (click)="toggleDropdown()">
      <div class="content" fxLayoutAlign="space-between center" fxLayout="row">
        <div class="custom-select__trigger mat-h3 text">
          <div class="text" [class.disabled]="isDisabled">
            <div header class="title-section"><span class="{{classSpanName}}"></span> {{title}}</div>
          </div>
        </div>
        <div fxLayoutAlign="end center" fxLayout="row">
          <div class="arrow-wrapper"><span class="arrow"></span></div>
        </div>
      </div>
    </div>

    <div *ngIf="isShowed" class="options" [@enterAnimation]>
      <div class="divider"></div>
      <div class="container">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>
